/*
 *
 * !!! DO NOT MODIFY DIRECTLY !!!
 *
 * @generated via scripts/import-icons
 *
 */

import React from 'react'

import { CssVars } from '../../../themes'
import { TextColorOverride } from '../../TextColorOverride'

export function Energy12({
  color,
}: {
  color?: React.ComponentProps<typeof TextColorOverride>['color']
}) {
  const node = (
    <svg
      fill="none"
      height="12"
      role="img"
      viewBox="0 0 12 12"
      width="12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M1.839 8.024A2.619 2.619 0 0 1 3 7.775c.466 0 .84.095 1.161.25a3.676 3.676 0 0 1 .73.487c.193.155.328.26.489.337.147.07.336.126.62.126s.473-.055.62-.126c.16-.077.296-.182.49-.337l.015-.013c.18-.143.415-.331.714-.475A2.619 2.619 0 0 1 9 7.775c.466 0 .84.095 1.161.25a3.674 3.674 0 0 1 .73.487c.193.155.328.26.489.337.147.07.336.126.62.126v1.25c-.466 0-.84-.095-1.161-.249a3.674 3.674 0 0 1-.714-.475l-.015-.013c-.194-.155-.33-.26-.49-.337A1.373 1.373 0 0 0 9 9.025c-.284 0-.473.055-.62.126-.16.077-.296.182-.49.337l-.015.013c-.18.143-.415.331-.714.475A2.618 2.618 0 0 1 6 10.225c-.466 0-.84-.095-1.161-.249a3.676 3.676 0 0 1-.73-.488c-.193-.155-.328-.26-.489-.337A1.373 1.373 0 0 0 3 9.025c-.284 0-.473.055-.62.126-.16.077-.296.182-.49.337l-.015.013c-.18.143-.415.331-.714.475A2.618 2.618 0 0 1 0 10.225v-1.25c.284 0 .473-.055.62-.126.16-.077.296-.182.49-.337l.015-.013c.18-.143.415-.331.714-.475Zm0-3A2.619 2.619 0 0 1 3 4.775c.466 0 .84.095 1.161.25a3.676 3.676 0 0 1 .73.487c.193.155.328.26.489.337.147.07.336.126.62.126s.473-.055.62-.126c.16-.077.296-.182.49-.337l.015-.013c.18-.143.415-.331.714-.475A2.619 2.619 0 0 1 9 4.775c.466 0 .84.095 1.161.25a3.674 3.674 0 0 1 .73.487c.193.155.328.26.489.337.147.07.336.126.62.126v1.25c-.466 0-.84-.095-1.161-.249a3.674 3.674 0 0 1-.714-.475l-.015-.013c-.194-.155-.33-.26-.49-.337A1.373 1.373 0 0 0 9 6.025c-.284 0-.473.055-.62.126-.16.077-.296.182-.49.337l-.015.013c-.18.143-.415.331-.714.475A2.618 2.618 0 0 1 6 7.225c-.466 0-.84-.095-1.161-.249a3.676 3.676 0 0 1-.73-.488c-.193-.155-.328-.26-.489-.337A1.373 1.373 0 0 0 3 6.025c-.284 0-.473.055-.62.126-.16.077-.296.182-.49.337l-.015.013c-.18.143-.415.331-.714.475A2.618 2.618 0 0 1 0 7.225v-1.25c.284 0 .473-.055.62-.126.16-.077.296-.182.49-.337l.015-.013c.18-.143.415-.331.714-.475Zm0-3A2.618 2.618 0 0 1 3 1.775c.466 0 .84.095 1.161.25a3.676 3.676 0 0 1 .73.487c.193.155.328.26.489.337.147.07.336.126.62.126s.473-.055.62-.126c.16-.077.296-.182.49-.337l.015-.013c.18-.143.415-.331.714-.475A2.618 2.618 0 0 1 9 1.775c.466 0 .84.095 1.161.25a3.674 3.674 0 0 1 .73.487c.193.155.328.26.489.337.147.07.336.126.62.126v1.25c-.466 0-.84-.095-1.161-.249a3.674 3.674 0 0 1-.714-.475l-.015-.013c-.194-.155-.33-.26-.49-.337A1.373 1.373 0 0 0 9 3.025c-.284 0-.473.055-.62.126-.16.077-.296.182-.49.337l-.015.013c-.18.143-.415.331-.714.475A2.618 2.618 0 0 1 6 4.225c-.466 0-.84-.095-1.161-.249a3.676 3.676 0 0 1-.73-.488c-.193-.155-.328-.26-.489-.337A1.373 1.373 0 0 0 3 3.025c-.284 0-.473.055-.62.126-.16.077-.296.182-.49.337l-.015.013c-.18.143-.415.331-.714.475A2.618 2.618 0 0 1 0 4.225v-1.25c.284 0 .473-.055.62-.126.16-.077.296-.182.49-.337l.015-.013c.18-.143.415-.331.714-.475Z"
        fill={CssVars.textColor}
        fillRule="evenodd"
      />
    </svg>
  )
  return color ? (
    <TextColorOverride color={color}>
      {({ rootClassName }) => (
        // NOTE(jare): Since the svg node's display is "inline", it can be
        // rendered with a little whitespace around it in certain cases. We
        // wrap it in a flexbox container to remove that whitespace.
        <span className={rootClassName} css={{ display: 'inline-flex' }}>
          {node}
        </span>
      )}
    </TextColorOverride>
  ) : (
    node
  )
}
